export default "__VITE_ASSET__dcb08e3a__"